import * as React from 'react';

import {Icon} from '.';
import {IconProps} from './type';
import {Path} from 'react-native-svg';

const LockClockIcon: React.FC<IconProps> = props => {
  return (
    <Icon viewBox="0 0 49 48" fill="none" {...props}>
      <Path
        d="M29.5 28.4L35.3 31.8L33.7 34.4L26.5 30V20H29.5V28.4ZM44.5 28C44.5 36.82 37.32 44 28.5 44C24.46 44 20.78 42.48 17.96 40H8.5C6.2 40 4.5 38.3 4.5 36V18C4.5 15.76 6.28 14.08 8.5 14V13C8.5 8.02 12.52 4 17.5 4C22.18 4 25.98 7.58 26.42 12.16C27.1 12.06 27.8 12 28.5 12C37.32 12 44.5 19.18 44.5 28ZM12.5 14H22.5V12.52C22.26 9.98 20.1 8 17.5 8C14.74 8 12.5 10.24 12.5 13V14ZM40.5 28C40.5 21.38 35.12 16 28.5 16C21.88 16 16.5 21.38 16.5 28C16.5 34.62 21.88 40 28.5 40C35.12 40 40.5 34.62 40.5 28Z"
        fill="#100E3A"
      />
    </Icon>
  );
};

export default LockClockIcon;
